import {GridInterface, GridOfOptions} from "../components/GridOfOptions";
import {CategoryInterface} from "./Category";
import {motion} from "framer-motion";
import navigationEffect from "../animations/navigationEffect";
import {Issue} from "../components/Issue";

interface HomeProps {
    allOptions: CategoryInterface[];
}

export const Home = ({allOptions}: HomeProps) => {
    let options: GridInterface[] = [];
    for (let i = 0; i < allOptions.length; i++) {
        options.push({
            title: allOptions[i].title,
            tag: `/category/${allOptions[i].tag}`,
            icon: allOptions[i].icon,
        })
    }

    if (options.length === 0) return (<Issue/>)

    return (
        <motion.div {...navigationEffect}>
            <h1 className="w-100 text-center mb-0">🫡 Тук си за малко учене? 🎬</h1>
            <p className="w-100 text-center text-info mb-0">Достъпът до сайта може да бъде ограничен при съмнение за злоупотреба.</p>
            <p className="w-100 text-center text-muted mb-5">Този сайт не се поддържа интензивно, ако имате въпроси, питайте админа.</p>
            <GridOfOptions
                options={options}
            />
        </motion.div>
    );
};